module.exports = __webpack_public_path__ + "img/carousel5.69d3ac56.jpg";